import Phaser from 'phaser';
import { QuestSystem } from '../systems/QuestSystem';
import { ScoreSystem } from '../systems/ScoreSystem';
import { Player } from '../objects/Player';
import { UIStyle } from './UIStyle';

export class DebugOverlay {
  private scene: Phaser.Scene;
  private text?: Phaser.GameObjects.Text;
  private enabled: boolean;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.enabled = false;
  }

  create(): void {
    if (!this.enabled) return;

    this.text = this.scene.add.text(8, 80, '', {
      ...UIStyle.textStyle('11px', '#00ff88'),
      backgroundColor: '#00000099',
      padding: { x: 6, y: 4 },
      lineSpacing: 3,
    });
    this.text.setDepth(300);
    this.text.setScrollFactor(0);
  }

  update(player: Player, score: ScoreSystem, quest: QuestSystem): void {
    if (!this.enabled || !this.text) return;

    const active = quest.getActiveQuests();
    const questInfo = active.length > 0
      ? active.map((q) => `${q.id} (${q.progress}/${q.maxProgress})`).join(', ')
      : 'none';

    this.text.setText([
      `[DEV] Scene: ${this.scene.scene.key}`,
      `Pos: ${Math.round(player.x)}, ${Math.round(player.y)}`,
      `Score: ${score.getScore()}`,
      `Quest: ${questInfo}`,
    ].join('\n'));
  }

  destroy(): void {
    this.text?.destroy();
  }
}
